<template>
  <router-link :to="to" :class="_class">
    <div :style="styles">
      <slot />
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'TRouterLink',
  props: {
    to: String,
    highlightColor: String,
    dense: Boolean,
    color: String
  },
  computed: {
    _class () {
      const c = ['t-router-link']
      this.highlightColor && c.push('highlighted')
      this.dense && c.push('dense')
      return c
    },
    styles () {
      return {
        '--text-color': this.color,
        '--highlight-text-color': /^var\(--.*$/.test(this.highlightColor) ? this.highlightColor.replace('--', '--on-') : this.color,
        '--highlight-bg-color': this.highlightColor
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.t-router-link {
  position: relative;
  text-decoration: inherit;
  padding: 13px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: $semi-bold;
  transition: background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
  &.router-link-active::before {
    content: "";
    display: "block";
    bottom: 0;
    right: 0;
    position: absolute;
    z-index: 0;
    background-color: var(--on-header);
    width: 100%;
    height: 4px;
  }

  div {
    color: var(--text-color);
    transition: color 0.15s cubic-bezier(0.4, 0, 0.2, 1);
  }

  &.highlighted {
    display: flex;
    align-items: center;
    justify-content: center;

    div {
      color: var(--highlight-text-color, --text-color);
      background-color: var(--highlight-bg-color);
      width: 176px;
      height: 58px;
      border-radius: 29px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      font-size: 16px;
      padding: 25px 11px;
      text-align: center;
      line-height: 1;
      font-weight: $semi-bold;
    }
  }

  &.dense {
    div {
      height: 41px;
      padding: 5px 30px;
      font-size: 12px;
      line-height: 0.92;
      letter-spacing: 0.24px;
    }
  }

  &.router-link-active {
    @include for-size(desktop-down) {
      background-color: var(--on-header);
      > div {
        color: var(--header);
      }
      &::before {
        display: none;
      }
    }
  }
}
</style>
